<!-- vertical layout -->
<!-- <div class="m-2"> -->
<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>
<!-- </div> -->
<!-- horizontal layout -->
<app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>